<template>
  <div>
    <bj-modal
      v-if="visible"
      v-model="visible"
      size="sm"
      :title="`${payload.id ? 'Edit' : 'Add'}  Devices`"
    >
      <div slot="content">
        <div class="row gutter-xs">
          <div class="col-12">
            <q-field>
              <autocomplete
                method="autocompleteBusiness"
                placeholder="Business..."
                @change="businessSelected"
                @clear="payload.business_id =null"
              />
            </q-field>
          </div>
          <div class="col-12 mt-3">
            <q-field>
              <q-select
                v-model="payload.provider"
                float-label="Provider"
                :options="providersOptions"
              />
            </q-field>
          </div>
          <div class="col-12 mt-3">
            <q-field>
              <q-input
                v-model="payload.serial_numbers"
                type="textarea"
                :rows="payload.id ? 1 : 5"
                float-label="Serial Numbers"
              />
            </q-field>
          </div>
          <div
            v-if="!isProd"
            class="col-12 mt-3"
          >
            <q-field>
              <q-toggle
                v-model="payload.is_real"
                label="Is Real Device"
              />
            </q-field>
          </div>
          <div class="col-12 row justify-end">
            <q-btn
              rounded
              size="md"
              class="q-mr-lg"
              color="grey"
              label="Cancel"
              @click="close"
            />
            <q-btn
              rounded
              size="md"
              color="primary"
              :label="`${payload.id ? 'Edit Device' : 'Add Devices'}`"
              @click="addDevice"
            />
          </div>
        </div>
      </div>
    </bj-modal>
  </div>
</template>

<script>

import { providers } from '@/constants/AccessHardware';
import Autocomplete from '@/components/autocomplete.vue';

export default {
  name: 'AddDevicesDialog',
  components: {
    Autocomplete,
  },
  data() {
    return {
      visible: false,
      loading: false,
      isProd: process && process.env.APP_ENV === 'production',
      payload: this.clone(basePayload),
      providersOptions: [providers.SENTRILOCK],
    };
  },
  methods: {
    show(payload = null) {
      this.visible = true;
      this.loading = false;
      if (payload !== null) {
        this.payload = {
          ...this.clone(basePayload),
          ...payload,
        };
      } else {
        this.payload = this.clone(basePayload);
      }
    },
    addDevice() {
      this.visible = false;
      const payloadData = (({
        business_id, provider, serial_numbers, is_real,
      }) => ({
        business_id, provider, serial_numbers, is_real,
      }))(this.payload);
      if (this.payload.id) {
        this.api().request('PUT', `admin/devices/${this.payload.id}`, payloadData).then(() => {
          this.loading = false;
          this.visible = false;
          this.uiNotify('Device saved successfully');
          this.$emit('added');
        }).catch((error) => {
          this.loading = false;
          this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
        });
      } else {
        this.api().request('POST', 'admin/devices', payloadData).then(() => {
          this.loading = false;
          this.visible = false;
          this.uiNotify('Devices added successfully');
          this.$emit('added');
        }).catch((error) => {
          this.loading = false;
          this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
        });
      }
    },
    businessSelected(event) {
      const { item, navigateWithKeyboardArrows } = event;
      if (!navigateWithKeyboardArrows) {
        this.payload.business_id = item.data.id;
      }
    },
    close() {
      this.visible = false;
      this.payload = this.clone(basePayload);
    },
  },
};

const basePayload = {
  business_id: null,
  business: {
    label: null,
    data: null,
  },
  provider: null,
  serial_numbers: '',
  is_real: true,
};

</script>

<style scoped>

</style>
